function removeDefaults(encodedValues, paramConfigMap) {
  var _a;

  for (var paramName in encodedValues) {
    if (((_a = paramConfigMap[paramName]) == null ? void 0 : _a.default) !== void 0 && encodedValues[paramName] !== void 0) {
      var encodedDefault = paramConfigMap[paramName].encode(paramConfigMap[paramName].default);

      if (encodedDefault === encodedValues[paramName]) {
        encodedValues[paramName] = void 0;
      }
    }
  }
}

export { removeDefaults };